<!--
  Breadcrumbs Component
  Navigation trail with links.
-->
<script lang="ts">
  import { Link } from 'svelte-routing';

  export let items: Array<{ label: string; href?: string }> = [];
</script>

<nav aria-label="Breadcrumb" class="flex items-center gap-1.5 text-sm">
  {#each items as item, i (item.label)}
    {#if i > 0}
      <svg
        class="w-3.5 h-3.5 text-text-muted"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="m9 18 6-6-6-6" />
      </svg>
    {/if}

    {#if item.href && i < items.length - 1}
      <Link to={item.href} class="text-text-secondary hover:text-text transition-colors">
        {item.label}
      </Link>
    {:else}
      <span class="text-text-muted">{item.label}</span>
    {/if}
  {/each}
</nav>
